import React from "react";
import { Container, Header, Icon } from "semantic-ui-react";

const ContactView: React.FC = () => {
  return (
    <Container
      style={{
        minHeight: "75vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "2rem",
      }}
    >
      <Header as="h1" textAlign="center">
        <Icon name="phone" />
        Contact Us
      </Header>

      <p style={{ fontSize: "1.1rem", marginBottom: "2rem", textAlign: "center" }}>
        We're happy to help! Reach out to us any time.
      </p>

      <div style={{ display: "flex", flexDirection: "column", gap: "1rem", width: "100%", maxWidth: "400px" }}>

        <a href="tel:+16615664426" style={{ width: "100%" }}>
          <button style={buttonStyle}>
            📞 Call Us
          </button>
        </a>

        <a href="sms:+16615664426" style={{ width: "100%" }}>
          <button style={buttonStyle}>
            💬 Text Us
          </button>
        </a>

        <a href="mailto:office@lundewaterllc.com" style={{ width: "100%" }}>
          <button style={buttonStyle}>
            ✉️ Email Us
          </button>
        </a>

      </div>
    </Container>
  );
};

const buttonStyle: React.CSSProperties = {
  width: "100%",
  padding: "1rem",
  fontSize: "1.1rem",
  backgroundColor: "#1b1b1b",
  color: "white",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
};

export default ContactView;
